module.exports = __webpack_public_path__ + "img/web1_2.3c048389.jpg";